type CallShell = {
  setCallAudio?: (active: boolean) => void;
  setSpeaker?: (on: boolean) => void;
};

const shell = (): CallShell | null => {
  const bridge = (window as Window & { ZeedcomShell?: CallShell }).ZeedcomShell;
  if (!bridge?.setSpeaker) return null;
  return bridge;
};

export const canRouteCallAudio = () => Boolean(shell());

export const setCallAudio = (active: boolean) => {
  try {
    shell()?.setCallAudio?.(active);
    if (active) shell()?.setSpeaker?.(false);
  } catch {
    /* shell absent */
  }
};

export const setCallSpeaker = (on: boolean) => {
  try {
    shell()?.setSpeaker?.(on);
  } catch {
    /* shell absent */
  }
};
